// get from http://emailregex.com/
// eslint-disable-next-line max-len
export const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

// matches string length between 8 to 24, lowerCase upperCase, number, special
export const passwordRegexFunction = (reqValue) => {
    if (!reqValue) {
        return true;
    }

    const groups = [
        /(?=.*[0-9])/,
        /(?=.*[a-z])/,
        /(?=.*[A-Z])/,
        /(?=.*[*.!@$%^&(){}\[\]:;<>,?\/~_+\-=|#])/
    ];

    let matchedGroups = 0;
    groups.forEach((group) => {
        if (reqValue.match(group)) {
            // eslint-disable-next-line no-plusplus
            matchedGroups++;
        }
    });

    return reqValue.match(/^.{8,20}$/) && matchedGroups >= 2;
};

// matches any non , characters
export const usernameRegex = /^((?!,).)*$/;

// matches any version 1.0.0
export const versionRegex = /^\d+(\.\d+){0,3}$/;

// matches any alphanumeric characters
export const alphaNumericRegex = /^[0-9a-zA-Z]*$/;

export const matchRegex = (valToMatch, regex) => {
    if (regex && valToMatch) {
        return (valToMatch.toString().match(regex));
    }

    return true;
};

export const wildCardsAsterisk = (val) => {
    const regex = /^.?([^*]*).?$/;
    let valuesArray = val && val.split(',');
    valuesArray = valuesArray || [];
    let match = true;
    for (let i = 0; i < valuesArray.length; i++) {
        valuesArray[i] = valuesArray[i].trim();
        if (valuesArray[i] === '**') {
            match = false;
        } else {
            match = matchRegex(valuesArray[i], regex);
        }

        if (!match) {
            break;
        }
    }
    return match;
};

export const wildCardsComma = (reqValue) => {
    let valuesArray = reqValue && reqValue.split(',');
    valuesArray = valuesArray || [];

    // only 5 values allowed
    if (valuesArray.length > 5) {
        return false;
    }

    let match = true;
    for (let i = 0; i < valuesArray.length; i++) {
        valuesArray[i] = valuesArray[i].trim();
        if (valuesArray[i] === '') {
            match = false;
            break;
        }
    }
    return match;
};
